import { create } from "zustand";

const useCountryStore = create((set, get) => ({
    country: null,
    flag: null,
    currency: null,
    price: null,

    setZustandCountry({ country, flag, currency, price }) {
        set({ country, flag, currency, price });
    },
}));

export default useCountryStore;
